export const TASK_PAGE_SIZE = 25;
export const JOB_SPENT_PAGE_SIZE = 10;
export const TASK_SPENT_PAGE_SIZE = 10;
export const MINUTE_DECIMAL_PLACES = 2;
export const SALES_PAGE_SIZE = 10;
export const ORDERS_PAGE_SIZE = 10;
export const MONEY_ENTRIES_PAGE_SIZE = 10;
export const TRANSFERS_PAGE_SIZE = 10;
export const FILES_PAGE_SIZE = 10;
